<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <DateBar
          :dateRange="dateRange"
          @updateRange="
            (value, startDate, index) => {
              dateRange = index;
              $emit('get-organizations', startDate);
            }
          "
          format-date="YYYY-MM-DD"
        />
        <DateFilters
          :initialDate="startDate"
          :finalDate="endDate"
          @updateInitialDate="$emit('update-dates', 'startDate', $event)"
          @updateFinalDate="$emit('update-dates', 'endDate', $event)"
        />
      </v-col>
    </v-row>
    <slot name="cards" />
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row v-if="!noFilters" dense>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  ref="button-search"
                  v-model="table.search"
                  @input="$emit('get-organizations')"
                  @click:append="
                    table.search ? $emit('get-organizations') : null
                  "
                  :label="$t('actions.search')"
                  solo
                  flat
                  dense
                  background-color="grey lighten-2"
                  append-icon="search"
                  hide-details
                />
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                  :items="statuses"
                  v-model="table.state"
                  @change="$emit('get-organizations')"
                  :label="$t('dashboard_clients.organizations.filter_by_state')"
                  item-text="text"
                  item-value="value"
                  outlined
                  hide-details
                  dense
                  class="mx-2"
                  clearable
                />
              </v-col>

              <!-- FILTRAR POR ORGANIZACIÓN -->
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-select
                  :items="organizationNames"
                  v-model="table.organizationName"
                  @change="$emit('get-organizations')"
                  :label="
                    $t('dashboard_clients.organizations.filter_by_organization')
                  "
                  item-text="name"
                  item-value="value"
                  outlined
                  flat
                  dense
                  class="mx-2"
                  hide-details
                  clearable
                >
                </v-select>
              </v-col>

              <v-col cols="12" sm="4" md="4" lg="3">
                <v-btn
                  ref="open-dialog-export"
                  @click.native="$emit('active-export-dialog')"
                  small
                  color="primary"
                  class="mr-2"
                >
                  <v-icon left>
                    cloud_download
                  </v-icon>
                  {{ this.$t("general.export") }}
                </v-btn>
              </v-col>
            </v-row>
            <slot v-else name="header" />
          </v-card-title>
          <!-- ref="table-donations" -->
          <v-data-table
            ref="table-organizations"
            :headers="headers"
            :items="table.items"
            :options="table.pagination"
            :footer-props="{ 'items-per-page-options': [5, 10, 15, 20] }"
            :items-per-page="table.pagination.itemsPerPage"
            :server-items-length="table.total"
            :loading="loading"
            no-data-text="Empty"
            no-results-text="sin resultados"
            @update:options="$emit('table-pagination', $event)"
          >
            <!-- SHOWS NO DATA -->
            <template v-slot:no-data>
              <div class="text-center pa-5 my-5">
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="grey--text">
                  {{ $t('dashboard_clients.organizations.no_data') }}
                </div>
              </div>
            </template>

            <template v-if="table.items.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          <span>
                            {{ item.id }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          <span>
                            {{ item.name }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td
                    :style="{
                      color: getStatusObject(item.status).color,
                      'font-weight': getStatusObject(item.status).fontWeight
                    }"
                    @click="$emit('open', item.id)"
                    class="cursor-pointer text-no-wrap"
                  >
                    {{ getStatusObject(item.status).text }}
                  </td>
                  <td>
                    <span>
                      {{ $moment(item.created_at).format("DD/MM/YYYY") }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{
                        item.firstUniqueDonationDate
                          ? item.firstUniqueDonationDate
                          : "-"
                      }}
                    </span>
                  </td>
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="">
                          <span>
                            {{
                              item.daysUntilFirstUniqueDonation
                                ? item.daysUntilFirstUniqueDonation
                                : item.daysUntilFirstUniqueDonation == 0
                                ? 0
                                : "-"
                            }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td>
                    <span>
                      {{
                        item.firstRecurrentDonationDate
                          ? item.firstRecurrentDonationDate
                          : "-"
                      }}
                    </span>
                  </td>
                  <td>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="">
                          <span>
                            {{
                              item.daysUntilFirstRecurrentDonation
                                ? item.daysUntilFirstRecurrentDonation
                                : "-"
                            }}
                          </span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </td>
                  <td>
                    <v-list-item-title class="">
                      $
                      {{
                        item.uniqueDonationsTotal
                          ? item.uniqueDonationsTotal
                          : "-"
                      }}</v-list-item-title
                    >
                  </td>
                  <td>
                    <v-list-item-title class="">
                      $
                      {{
                        item.recurrentDonationsTotal
                          ? item.recurrentDonationsTotal
                          : "-"
                      }}</v-list-item-title
                    >
                  </td>
                  <td>
                    <v-list-item-title class="">
                      $
                      {{
                        item.lastMonthUniqueDonationsTotal
                          ? item.lastMonthUniqueDonationsTotal
                          : "-"
                      }}</v-list-item-title
                    >
                  </td>

                  <td>
                    <v-list-item-title class="">
                      $
                      {{
                        item.lastMonthRecurrentDonationsTotal
                          ? item.lastMonthRecurrentDonationsTotal
                          : "-"
                      }}</v-list-item-title
                    >
                  </td>
                  <td>
                    {{ item.hasAutomationActive ? "SI" : "NO" }}
                  </td>
                  <td>
                    {{ item.totalEmailSent ? item.totalEmailSent : "-" }}
                  </td>
                  <td>
                    {{ item.activeSequences ? item.activeSequences : "-" }}
                  </td>
                  <td>
                    {{ item.hasRecurrentPaymentsActive ? "SI" : "NO" }}
                  </td>
                  <td>
                    {{ item.recurrentPaymentsDonationsTotal }}
                  </td>
                  <td>
                    {{ item.specificCampaignsCertificates }}
                  </td>
                  <td>
                    {{ item.globalCampaignsCertificates }}
                  </td>
                  <td>
                    {{ item.hasLandingActive ? "SI" : "NO" }}
                  </td>
                  <td>
                    {{ item.activeLandings }}
                  </td>
                  <td>
                    {{ item.lastNewsletterDate }}
                  </td>
                  <td>
                    {{ item.activeForms }}
                  </td>
                  <td>
                    {{ item.hasPetitionsActive ? "SI" : "NO" }}
                  </td>
                  <td>
                    {{ item.autorresponders }}
                  </td>
                  <td>
                    {{ item.hasCrowdfundingActive ? "SI" : "NO" }}
                  </td>
                  <td>
                    {{
                      item.licence && item.licence.name
                        ? item.licence.name
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.licence && item.licence.amount
                        ? item.licence.amount
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.licence && item.licence.currency
                        ? item.licence.currency
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.licence && item.licence.frequency
                        ? item.licence.frequency
                        : "-"
                    }}
                  </td>
                  <td>
                    {{ item.licence && item.licence.automation ? "SI" : "NO" }}
                  </td>
                  <td>
                    {{
                      item.licence &&
                      item.licence.automation &&
                      item.licence.automation_amount
                        ? item.licence.automation_amount
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.licence &&
                      item.licence.automation &&
                      item.licence.automation_currency
                        ? item.licence.automation_currency
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.licence && item.licence.special_projects
                        ? "SI"
                        : "NO"
                    }}
                  </td>
                  <td>
                    {{
                      item.licence &&
                      item.licence.special_projects &&
                      item.licence.special_projects_amount
                        ? item.licence.special_projects_amount
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      item.licence &&
                      item.licence.special_projects &&
                      item.licence.special_projects_currency
                        ? item.licence.special_projects_currency
                        : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DateFilters from "@/components/Common/DateFilters/Index";
import DateBar from "@/components/Common/DateBar/Index";
import organizationMixin from "@/mixins/organization";
import { organizationService } from "@/services/organization.service";
export default {
  components: { DateBar, DateFilters },
  mixins: [organizationMixin],
  props: {
    noFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    table: {
      type: Object,
      required: true,
      default: () => {}
    },
    startDate: {
      type: String,
      required: true,
      default: new Date()
    },
    endDate: {
      type: String,
      required: true,
      default: new Date()
    },
    headers: {
      type: Array,
      required: true,
      default: () => []
    },
    showOptions: {
      type: Boolean,
      required: false,
      default: false
    },
    statuses: {
      type: Array,
      required: false,
      default: () => []
    },
    groups: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      dateRange: 3,
      organizationNames: []
    };
  },
  async created() {
    this.getAllOrganizations();
  },
  methods: {
    async getAllOrganizations() {
      try {
        const response = await organizationService.getAllOrganizations();
        const data = response.data;
        this.organizationNames = data.map(org => {
          return org.name;
        });
        this.organizations = response.data;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
